import React, { useEffect, useMemo } from 'react'
import styled, { ThemeProvider, createGlobalStyle } from 'styled-components'
import Header from '../shared/Header'
import Footer from '../shared/Footer'
import { getTheme, applyThemeToDocument, resolveThemeName, THEME_EVENT } from '../../utility/theme'

// Mouse clicks must never leave a lingering focus box on links/buttons;
// keyboard focus keeps a visible accent ring (:focus-visible only).
const FocusStyles = createGlobalStyle`
	a:focus, button:focus {
		outline: none;
	}
	.btn:focus:not(:focus-visible) {
		box-shadow: none;
	}
	a:focus-visible, button:focus-visible {
		outline: 2px solid rgba(16, 171, 255, 0.5);
		outline-offset: 3px;
	}
`

const Wrapper = styled.div`
	min-height: 100vh;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	/* map-specific: below 1200px the Header is the main site's fixed 64px top
	   bar; >=1200px it is a fixed left rail and content offsets via
	   styles.spacing.navBar inside the screens instead */
	padding-top: ${({ $isWebView }) => ($isWebView ? '0' : '64px')};
	@media screen and (min-width: 1200px) {
		padding-top: 0;
	}
	max-width: 100vw;
`

/**
 *
 * @param {{isWebView?:boolean, children:any, style?:React.CSSProperties, footerStyle?:React.CSSProperties, noFooter?:boolean}} props
 * @returns
 */
export default function ScreenWrapper({
	isWebView,
	children,
	style,
	footerStyle,
	noFooter,
}) {
	const [themeName, setThemeNameState] = React.useState(resolveThemeName)
	const theme = useMemo(() => getTheme(themeName), [themeName])

	useEffect(() => {
		applyThemeToDocument(theme)
	}, [theme])

	useEffect(() => {
		const onChange = e => setThemeNameState(e.detail?.name || resolveThemeName())
		window.addEventListener(THEME_EVENT, onChange)
		return () => window.removeEventListener(THEME_EVENT, onChange)
	}, [])

	return (
		<ThemeProvider {...{ theme }}>
			<FocusStyles />
			<Wrapper $isWebView={Boolean(isWebView)} {...{ style }}>
				{!Boolean(isWebView) && <Header />}
				{children}
				{!Boolean(isWebView) && !noFooter && (
					<Footer style={footerStyle} />
				)}
			</Wrapper>
		</ThemeProvider>
	)
}
